import type { GetAssetHydrated } from '../contexts';
import { FIRST_PASS_SENTINEL, NO_FIELDS_SENTINEL } from './constants';
import { getVisibleFieldIds } from './getVisibleFieldIds';

export const getAssetHydrated: GetAssetHydrated = (assetId, query, cache) => {
  const visibleFieldIds = getVisibleFieldIds(query);
  if (visibleFieldIds) {
    if (visibleFieldIds.length === 0)
      return cache.get(assetId)?.has(NO_FIELDS_SENTINEL) ?? false;
    return visibleFieldIds.every((fieldId) => cache.get(assetId)?.has(fieldId));
  }
  return cache.get(assetId)?.has(FIRST_PASS_SENTINEL) ?? false;
};
